module.exports = "/_next/static/resources/life1-a3b25ed1497e05cdc2353348d30fc328.webp";